<div class="container m-b-20 layout-row align-end gap-20px">
  <button
    mat-raised-button
    color="primary"
    [routerLink]="['create']"
    *LOSxHasPermission="'CREATE_DELINQUENCY_BUCKET'"
  >
    <fa-icon icon="plus" class="m-r-10"></fa-icon>
    {{ 'labels.buttons.Create Delinquency Bucket' | translate }}
  </button>
</div>

<div class="container">
  <div class="layout-row">
    <mat-form-field class="flex-fill">
      <mat-label>{{ 'labels.inputs.Filter' | translate }}</mat-label>
      <input matInput (keyup)="applyFilter($event.target.value)" />
    </mat-form-field>
  </div>

  <div class="mat-elevation-z8">
    <table mat-table [dataSource]="dataSource" matSort>
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'labels.inputs.Name' | translate }}</th>
        <td mat-cell *matCellDef="let delinquencyBucket">{{ delinquencyBucket.name }}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns" [routerLink]="[row.id]" class="select-row"></tr>
    </table>

    <mat-paginator [pageSizeOptions]="[10, 25, 50, 100]" showFirstLastButtons></mat-paginator>
  </div>
</div>
